import type { FilterBreakdown } from '@filmsloth/shared';
import { useT } from '../i18n/index.js';

/**
 * Says how big the deck is, and — when it is empty or nearly so — which
 * filter to loosen.
 *
 * A bare "0 movies match" leaves the host toggling chips at random, which is
 * the exact twenty-minute spiral this app exists to end.
 */
export function FilterPreview({ preview }: { preview: FilterBreakdown | null }) {
  const t = useT();
  if (!preview) return null;

  const { count, suggestion, withoutGenres, withoutRuntime, withoutYear, withoutRating } = preview;

  if (count === 0) {
    const hint =
      suggestion === 'genres'
        ? t('create.tryWithoutGenres', { count: withoutGenres })
        : suggestion === 'runtime'
          ? t('create.tryWithoutRuntime', { count: withoutRuntime })
          : suggestion === 'year'
            ? t('create.tryWithoutYear', { count: withoutYear })
            : suggestion === 'rating'
              ? t('create.tryWithoutRating', { count: withoutRating })
              : t('create.tryMoreProviders');
    return (
      <p className="banner banner--warn">
        {t('create.noMovies')} {hint}
      </p>
    );
  }

  return (
    <p className="muted small center">
      {t('create.matchingMovies', { count })}
      {/* Only worth mentioning while the deck is thin enough that a short
          evening could run it dry. */}
      {count < 10 && suggestion === 'genres' && withoutGenres > count
        ? ` · ${t('create.tryWithoutGenres', { count: withoutGenres })}`
        : null}
      {count < 10 && suggestion === 'runtime' && withoutRuntime > count
        ? ` · ${t('create.tryWithoutRuntime', { count: withoutRuntime })}`
        : null}
      {count < 10 && suggestion === 'year' && withoutYear > count
        ? ` · ${t('create.tryWithoutYear', { count: withoutYear })}`
        : null}
      {count < 10 && suggestion === 'rating' && withoutRating > count
        ? ` · ${t('create.tryWithoutRating', { count: withoutRating })}`
        : null}
    </p>
  );
}
